module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-slider"
  }, [_c('nav', {
    staticClass: "c-slider__nav c-slider__nav--left",
    class: {
      's--hovered': _vm.toggleHover && _vm.direction === 'prev' && !_vm.switchingSlides, 's--hide': _vm.toggleHover && _vm.direction === 'next'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.switchSlide('prev')
      }
    }
  }, [_c('div', [_c('p', [_vm._v("prev")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.prevProjectTitle))])])]), _vm._v(" "), _c('nav', {
    staticClass: "c-slider__nav c-slider__nav--right",
    class: {
      's--hovered': _vm.toggleHover && _vm.direction === 'next' && !_vm.switchingSlides, 's--hide': _vm.toggleHover && _vm.direction === 'prev'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.switchSlide('next')
      }
    }
  }, [_c('div', [_c('p', [_vm._v("next")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.nextProjectTitle))])])]), _vm._v(" "), _c('div', _vm._l((_vm.projects), function(project) {
    return _c('slider-item', {
      attrs: {
        "project": project
      }
    })
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0a770944!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Slider/Slider.vue
// module id = 85
// module chunks = 2